import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

/** MUI-compatible icons. Inherit color and fontSize from SvgIcon/IconButton. */
export function JaegerIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M8.1 3.3c.2-.8.8-1.3 1.6-1.3h4.6c.8 0 1.4.5 1.6 1.3l.9 4.2H7.2l.9-4.2Z" />
      <path d="M3.2 8.1c0-.6.5-1.1 1.1-1.1h15.4c.6 0 1.1.5 1.1 1.1s-.5 1.1-1.1 1.1H4.3c-.6 0-1.1-.5-1.1-1.1Z" />
      <path d="M17 4.4 20 2l-.8 3.5-1.7 1.2-.5-2.3Z" />
      <path d="M7.6 10.1h8.8v2.1c0 2.6-1.9 4.5-4.4 4.5s-4.4-1.9-4.4-4.5v-2.1Z" />
      <path d="M5 22v-1.5c0-2.2 1.7-3.8 4.1-4.2l2.9 1.8 2.9-1.8c2.4.4 4.1 2 4.1 4.2V22H5Z" />
    </SvgIcon>
  );
}

export function KundeIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <circle cx="6.3" cy="5.1" r="2.7" />
      <path d="M2.5 10.3c0-1.5 1.3-2.7 2.8-2.7h2c1.3 0 2.3.8 2.7 1.9l1.2 3.2 1.9 1.1-.9 1.6-2.5-1.4c-.3-.2-.6-.5-.7-.9l-.6-1.6v6.6H2.5v-7.8Z" />
      <path d="M12.1 10.3h9.5l-1.7 6.1h-6.1l-1.7-6.1Z" />
      <path d="M9.9 9.3h2l2.7 8.7h5.7v1.7h-6.9L9.9 9.3Z" />
      <circle cx="15" cy="21" r="1.1" />
      <circle cx="19.4" cy="21" r="1.1" />
    </SvgIcon>
  );
}
